import { PageBreakIcon, HorizontalRuleIcon } from "outline-icons";
import { EditorState } from "prosemirror-state";
import * as React from "react";
import isNodeActive from "../../../shared/editor/queries/isNodeActive";
import { MenuItem } from "../../../shared/editor/types";
import { globalIntl } from "src/utils/hepler";

export default function dividerMenuItems(
  state: EditorState,
  // dictionary: Dictionary
): MenuItem[] {
  const { schema } = state;

  return [
    {
      name: "hr",
      tooltip: globalIntl("editor.pageBreak"),
      attrs: { markup: "***" },
      active: isNodeActive(schema.nodes.hr, { markup: "***" }),
      icon: <PageBreakIcon />,
    },
    {
      name: "hr",
      tooltip: globalIntl("editor.hr"),
      attrs: { markup: "---" },
      active: isNodeActive(schema.nodes.hr, { markup: "---" }),
      icon: <HorizontalRuleIcon />,
    },
  ];
}
